import { withAssetSelector } from '@shootsta/common-react';
import MediaSectionComponent from '../components/MediaSection';

export default withAssetSelector(MediaSectionComponent);
